import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let CreateStaffSelector = class CreateStaffSelector extends Vue {
    render(h) {
        return h("a-input", { props: Object.assign({}, this.opts) }, [
            h("i", {
                props: {
                    type: "user"
                },
                slot: 'suffix',
                'class': [
                    'aufontAll',
                    'h-icon-all-process-o'
                ]
            })
        ]);
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], CreateStaffSelector.prototype, "opts", void 0);
CreateStaffSelector = tslib_1.__decorate([
    Component({
        name: 'CreateStaffSelector',
    })
], CreateStaffSelector);
export default CreateStaffSelector;
